module.exports = __webpack_public_path__ + "static/media/admins.3493de58.svg";